import Form from '@utils/form'
import options from './config/options'

export default new Form('performance.rate')
  .url('/srmPerformanceLevel/addSrmPerformanceLevel', process.env.VUE_APP_PURCHASE_API)
  .title('formTitle.baseInfo')
  .add('levelName').required('requiredLevelName').placeholder('performance.rate.requiredLevelName')
  .add('topScore').merge('number').required('requiredTopScore')
  .add('bottomScore').merge('number').required('requiredBottomScore')
  .add('performanceStrategy').op(options)
  .add('remarks').merge('textarea')
  .end()
